import Icon from '../components/Icon.vue'

Icon.register({
  'lira-sign': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M372 256H324C317.6 256 312 260.9 312 267.2 312 368 230.2 416 144 416V256.8L278.6 226.9A12-12 0 0 1 288 215.2V174.2C288 166.5 280.9 160.8 273.4 162.5L144 191.2V160.8L278.6 130.9A12-12 0 0 1 288 119.2V78.2C288 70.5 280.9 64.8 273.4 66.5L144 95.2V44C144 37.4 138.6 32 132 32H76C69.4 32 64 37.4 64 44V113L9.4 125.1A12-12 0 0 1 0 136.8V177.8C0 185.5 7.1 191.2 14.6 189.5L64 178.6V209L9.4 221.1A12-12 0 0 1 0 232.8V273.8C0 281.5 7.1 287.2 14.6 285.5L64 274.6V468C64 474.6 69.4 480 76 480H155.6C289.7 480 378.8 402.2 384 268.4 384.3 261.6 378.8 256 372 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/lira-sign.js
// module id = SAPc
// module chunks = 144